
export { LucideIcon } from "/codebuild/output/src2315228166/src/packages/shared-components/src/components/LucideIcon.tsx"